// config.js
const config = {
  backendUrl:
    process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === "production"
      ? "https://loyaltyapi.dilipsindia.com"
      : "http://localhost:5055"),
};

export default config;